module.exports = __webpack_public_path__ + "media/images/facebook-48187f990f07e32c1230d5423b4591b4.svg";